import {InjectionToken, WritableSignal} from '@angular/core';

/**
 * Injection token that provides a signal holding the entire
 * UI configuration object (config_data) fetched at startup.
 */
export const UI_CONFIG = new InjectionToken<WritableSignal<any>>('UI Config');
